<!--
@Author: MIYONGLE
@Desc: PC端头部
@Date: 2021-04-16 18时
-->
<template>
  <div id="menuNav">
    <!-- nav背景 -->
    <div
      class="nav-pc-bg"
      :style="{
        opacity: opacityNum,
        left: -scrollLeft + 'px',
        '-khtml-opacity': opacityNum
      }"
    ></div>

    <!-- nav开始 -->
    <!-- <div :class="!isPCextension?'nav-pc-main':'nav-isPCextension-main'" :style="{left: -scrollLeft + 'px' }"> -->
    <div class="nav-pc-main" :style="{ left: -scrollLeft + 'px' }">
      <!-- 左边 -->
      <img
        v-if="getAddress === 'hui15'"
        src="../../static/pc/nav_logo.png"
        alt="慧用工Logo"
        class="pc-nav-left"
      />
      <img
        v-if="getAddress === 'hui5'"
        src="../../static/pc/nav_logo.png"
        alt="汇用工Logo"
        class="pc-nav-left"
      />
      <img
        v-if="getAddress === 'hui6'"
        src="../../static/pc/nav_logo.png"
        alt="会用工Logo"
        class="pc-nav-left"
      />
      <img
        v-if="getAddress === 'hui12'"
        src="../../static/pc/nav_logo.png"
        alt="惠用工Logo"
        class="pc-nav-left"
      />
      <!-- <img v-if="getAddress === 'hyhyg'" src="../../static/pc/hyhyg_logo.png" alt="衡阳慧用工Logo" class="pc-nav-left" /> -->

      <!-- 右边 -->
      <!-- <div class="pc-nav-right" v-if="!isPCextension"> -->
      <div class="pc-nav-right">
        <!-- item -->
        <div class="pc-nav-menusList">
          <span
            v-for="(item, index) in menusList"
            :class="item.className"
            :key="index"
            @click="clickNav(item, 'isClick')"
            @mouseleave="leaveNav(item)"
          >
            {{ item.name }}
            <span v-show="item.displayMenus" class="displayMenus">
              <i
                v-for="(itemSonVal, value) in item.itemList"
                :class="itemSonVal.className"
                :key="value"
                @click.stop="clickNavMenus(item, itemSonVal)"
              >
                {{ itemSonVal.name }}
              </i>
            </span>
          </span>
        </div>

        <!-- 登录 -->
        <!-- <span class="pc-nav-login" @click="loginTypeVisible = true"">登录</span> -->
        <span v-if="!isPCextension" class="pc-nav-login" @click="jumpWebm(1)"
          >登录</span
        >

        <!-- 免费体验 -->
        <span class="pc-nav-free" @click="jumpPage">免费体验</span>

        <!-- 咨询热钱 -->
        <span class="pc-nav-hotline">
          <i>咨询热线：</i>
          <i>400-085-5500</i>
        </span>
      </div>
    </div>

    <!-- 登录弹窗 -->
    <!-- <div class="login-box-modal" v-show="loginTypeVisible" @click="loginTypeVisible = false">
      <div class="login-type-content">
        <img class="title" src="../../static/pc/select_xt.png" alt="请选择系统">

        <div class="login-type-list">
          <div class="login-type-item" @click="jumpWebm(1)">
            <img src="../../static/pc/pic-1.png" alt="">
            <span>慧用工智能结算系统</span>
          </div>
          <div class="login-type-item" @click="jumpWebm(2)">
            <img src="../../static/pc/pic-2.png" alt="">
            <span>慧用工网络货运系统</span>
          </div>
          <div class="login-type-item">
            <img src="../../static/pc/pic-3.png" alt="" id="sub" @click="jumpWebm(3)">
            <span>扫码下载慧广通App</span>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script type="text/javascript">
import {
  checkNull,
  setSession,
  getSession,
  jumpAnchorPoint
} from "../filters/filters";
import { PCMENUSLIST } from "../service/businessConsts";
// PCHYMENUSLIST
export default {
  name: "menusNav",
  data() {
    return {
      opacityNum: 0,
      getAddress: "",
      loginTypeVisible: false,
      menusList: PCMENUSLIST,
      scrollLeft: 0,
      scrollTop: 0,
      showBackground: false,
      isPCextension: false //PC端定制推广页特殊展示
    };
  },

  watch: {
    "$route.path": {
      handler(to, from) {
        let noBackgroundArr = ["/jobRecruit", "/jobPost", "/jobRecruitDetail"];
        this.changeBackground(noBackgroundArr, to);
      },
      deep: true, // 深度观察监听
      immediate: true // 第一次初始化渲染就可以监听到
    }
  },

  components: {},

  created() {
    this.isIE();
    let pathTemp = window.location.hash;
    let path = pathTemp.substring(1, pathTemp.length);
    if (path === "/extensionPage") {
      this.isPCextension = true;
    }
    // console.log(path,'yuyuuyy');

    eventBus.$on("brotherClickNav", (data, itemSonObj) => {
      this.menusList.forEach(item => {
        item.className = "pc-nav-item";
        if (data.name === item.name) {
          item.className = "pc-nav-item pc-nav-item-active";
          if (!checkNull(item.itemList)) {
            item.itemList.forEach(itemSon => {
              if (itemSon.name == itemSonObj.title) {
                itemSon.className = "pc-nav-itemSon pc-nav-itemSon-active";
              } else {
                itemSon.className = "pc-nav-itemSon";
              }
            });
          }
        }
      });
    });

    //页面刷新回显nav
    let menuName = getSession("menuName");
    let menuSonName = getSession("menuSonName");

    if (!checkNull(menuName)) {
      this.menusList.forEach(item => {
        item.className = "pc-nav-item";
        if (menuName === item.name) {
          item.className = "pc-nav-item pc-nav-item-active";
          if (!checkNull(item.itemList)) {
            item.itemList.forEach(itemSon => {
              if (itemSon.name == menuSonName) {
                itemSon.className = "pc-nav-itemSon pc-nav-itemSon-active";
              } else {
                itemSon.className = "pc-nav-itemSon";
              }
            });
          }
        }
      });
    }

    // 获取展示logo的标记
    this.getAddress = this.getSiteAddress().whichHui;
  },

  mounted() {
    this.isIE();
  },

  methods: {
    changeBackground(arr, path) {
      if (arr.includes(path)) {
        this.opacityNum = 1;
        this.showBackground = true;
      } else {
        this.opacityNum = 0;
        this.showBackground = false;
      }
    },

    //nav点击隐藏
    clickNav(data) {
      for (let item of this.menusList) {
        if (item.name === data.name) {
          item.displayMenus = true;

          if (!data.isSubCategory) {
            item.className = "pc-nav-item pc-nav-item-active";
          } else {
            item.className =
              "pc-nav-item pc-nav-item-active pc-nav-item-active-img";
          }
        } else {
          item.displayMenus = false;
          item.className = "pc-nav-item";

          //点击一级菜单去掉二级
          this.menusList.forEach(val => {
            if (val.isSubCategory) {
              val.itemList.forEach(valSon => {
                if (
                  valSon.className == "pc-nav-itemSon pc-nav-itemSon-active"
                ) {
                  valSon.className = "pc-nav-itemSon";
                }
              });
            }
          });
        }
      }

      setSession("menuName", data.name);

      let hash = window.location.hash;
      let sIndex = hash.indexOf("?");

      if (hash.indexOf("?") > -1) {
        this.$router.push({
          path: data.path + hash.substr(sIndex, hash.length - 1)
        });
      } else {
        this.$router.push({ path: data.path });
      }

      //关于我们点击
      if (data.name == "关于我们") {
        setSession("aboutTabId", "1");
      }

      //首页点击
      if (data.name == "首页") {
        jumpAnchorPoint("#menuNav");
      }
    },

    //子目录展示隐藏
    clickNavMenus(item, itemSonVal) {
      item.displayMenus = false;
      for (let val of item.itemList) {
        if (itemSonVal.name === val.name) {
          val.className = "pc-nav-itemSon pc-nav-itemSon-active";
        } else {
          val.className = "pc-nav-itemSon";
        }
      }

      //点击二级菜单去掉一级
      if (item.name != "产品服务" || item.name != "解决方案") {
        this.menusList.forEach(val => {
          if ((val.className = "pc-nav-item pc-nav-item-active")) {
            val.className = "pc-nav-item";
          }
        });
      }

      if (item.name == "产品服务") {
        item.className = "pc-nav-item pc-nav-item-active";
        this.menusList[2].itemList.forEach(item => {
          item.className = "pc-nav-itemSon";
        });
      }

      if (item.name == "解决方案") {
        item.className = "pc-nav-item pc-nav-item-active";
        this.menusList[1].itemList.forEach(item => {
          item.className = "pc-nav-itemSon";
        });
      }

      setSession("menuSonName", itemSonVal.name);
      setSession("menuName", item.name);
      let hash = window.location.hash;
      if (hash.indexOf("?") > -1) {
        let sIndex = hash.indexOf("?");
        this.$router.push({
          path: itemSonVal.path + hash.substr(sIndex, hash.length - 1)
        });
      } else {
        this.$router.push({ path: itemSonVal.path });
      }
    },

    leaveNav(data) {
      data.displayMenus = false;
      if (
        data.className ===
        "pc-nav-item pc-nav-item-active pc-nav-item-active-img"
      ) {
        data.className = "pc-nav-item pc-nav-item-active";
      }
    },

    //登录按钮跳转
    jumpWebm(type) {
      this.loginTypeVisible = false;
      if (type == 2) {
        window.open("https://go.hvyogo.com", "_blank");
      } else if (type == 3) {
        window.open(
          "http://wccyrdemo.sinoiov.cn:12009/standalone/%E6%85%A7%E5%B9%BF%E9%80%9A/download.html",
          "_blank"
        );
      } else {
        var whichAddress = window.location.hostname;
        if (whichAddress == "b.hvyogo.com") {
          window.open("http://bweb.hvyogo.com", "_blank");
        } else if (whichAddress == "www.hyhaifu.com") {
          window.open("http://web.hyhaifu.com", "_blank");
        } else if (whichAddress == "www.hnhifu.com") {
          window.open("http://web.hnhaifu.com", "_blank");
        } else {
          window.open("https://web.hvyogo.com", "_blank");
        }
      }
    },

    //滚动条滑动的距离
    handelScroll() {
      this.scrollTop =
        window.pageYOffset ||
        document.body.scrollTop ||
        document.scrollingElement.scrollTop;

      // 解决ie兼容性
      if (!checkNull(this.scrollLeft)) {
        this.scrollLeft =
          window.pageXOffset ||
          document.body.scrollLeft ||
          document.scrollingElement.scrollLeft ||
          document.documentElement.scrollLeft;
      }

      // ljl - 1125
      if (!!this.showBackground) {
        return false;
      }

      if (this.scrollTop > 0) {
        let opacity = this.scrollTop / 200;
        opacity = opacity > 1 ? 1 : opacity;
        this.opacityNum = opacity;
      } else {
        this.opacityNum = 0;
      }
    },

    //ie浏览器的环境
    isIE() {
      //ie?
      if (!!window.ActiveXObject || "ActiveXObject" in window) {
        this.opacityNum = 0.8;
      } else {
        window.addEventListener("scroll", this.handelScroll, true);
      }
    },

    jumpPage() {
      eventBus.$emit("pcOperaDiaLog", true);
    }
  }
};
</script>

<style lang="scss" scoped>
.nav-pc-bg {
  height: 70px;
  line-height: 70px;
  position: fixed;
  width: 100%;
  right: 0;
  top: 0;
  z-index: 999;
  background: #100f0f;
  min-width: 1300px;
}

//顶部开始
.nav-pc-main {
  height: 70px;
  line-height: 70px;
  position: fixed;
  width: 100%;
  min-width: 1300px;
  right: 0;
  top: 0;
  z-index: 999;
  display: flex;
  justify-content: space-between;
  padding-left: 20px;
  .pc-nav-left {
    width: 127px;
    height: 60px;
    margin-top: 5px;
    img {
      width: 100%;
    }
  }

  .pc-nav-right {
    display: flex;
    justify-content: space-between;

    .pc-nav-menusList {
      font-size: 16px;
      cursor: pointer;
      .pc-nav-item:hover {
        color: #1985ff;
      }

      .pc-nav-item:nth-child(1):hover,
      .pc-nav-item:nth-child(2):hover,
      .pc-nav-item:nth-child(3):hover {
        background: url(../../static/pc/nav_icon_caidan.png) no-repeat bottom
          center;
        background-position: 50px 50px;
        .displayMenus {
          display: block !important;
        }
      }
      // ljl-1125
      // .pc-nav-item:nth-child(2):hover,.pc-nav-item:nth-child(3):hover{
      //   background: url(../../static/pc/nav_icon_caidan.png) no-repeat bottom center;
      //   background-position: 50px 50px;
      //   .displayMenus{
      //     display: block !important;
      //   }
      // }

      // .pc-nav-item:nth-child(2),.pc-nav-item:nth-child(3)    ljl-1125

      .pc-nav-item:nth-child(1),
      .pc-nav-item:nth-child(2),
      .pc-nav-item:nth-child(3) {
        position: relative;

        span {
          position: absolute;
          left: 0;
          z-index: 9999;
          color: #fff;
          background: #ffffff;
          width: 126px;
          display: block;
          top: 72px;
          .pc-nav-itemSon {
            display: block;
            font-size: 16px;
            color: #403f3f;
            line-height: 48px;
            height: 48px;
            font-style: normal;
          }

          .pc-nav-itemSon:hover {
            background: #016ee9;
            color: #fff;
          }

          .pc-nav-itemSon-active {
            color: #fff;
            background: #1985ff;
          }
        }
      }
    }

    .pc-nav-item {
      color: #fff;
      width: 126px;
      height: 100px;
      line-height: 70px;
      display: inline-block;
    }

    .pc-nav-item-active {
      color: #1985ff;
      // margin-right: 69px;
    }

    .pc-nav-item-active-img {
      background: url(../../static/pc/nav_icon_caidan.png) no-repeat bottom
        center;
      background-position: 50px 50px;
    }

    .pc-nav-login {
      border: 1px solid #1985ff; /*no*/
      border-radius: 18px;
      width: 88px;
      height: 36px;
      color: #1985ff;
      font-size: 16px;
      line-height: 36px;
      margin-left: 40px;
      margin-top: 17px;
      cursor: pointer;
    }

    .pc-nav-free {
      width: 88px;
      height: 36px;
      line-height: 36px;
      color: #fff;
      font-size: 16px;
      background: #1985ff;
      border-radius: 18px;
      margin-top: 17px;
      margin-left: 20px;
      cursor: pointer;
    }

    .pc-nav-hotline {
      background: #1985ff;
      color: #fff;
      padding: 0 40px;
      box-sizing: border-box;
      margin-left: 20px;
      i {
        display: block;
        line-height: normal;
        text-align: left;
        font-style: normal;
      }

      i:first-child {
        font-size: 14px;
        margin-top: 13px;
      }

      i:last-child {
        font-size: 18px;
        font-family: PingFangSC-Medium;
      }
    }
  }
}

// .nav-isPCextension-main{
//   width: 1200px;
//   margin: 0 auto;
//   height:70px;
//   line-height:70px;
//   position:fixed;
//   right:0;
//   top: 0;
//   z-index:999;
//   display: flex;
//   justify-content: space-between;
//   padding-left: 20px;
//   .pc-nav-left{
//     width: 127px;
//     height: 60px;
//     margin-top: 5px;
//     img{
//       width: 100%;
//     }
//   }
// }

.displayMenus {
  box-shadow: 0 2px 11px 0 rgba(0, 0, 0, 0.2);
}

//登录
.login-box-modal {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 1000000;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  .login-type-content {
    width: 1200px;
    padding: 100px;
    background-color: #fff;
    .title {
      width: 198px;
      height: 38px;
      margin-bottom: 68px;
    }
    .login-type-list {
      display: flex;
      justify-content: space-between;
      margin-bottom: 64px;
      .login-type-item {
        width: 300px;
        img {
          width: 100%;
          height: 312px;
        }
        span {
          width: 100%;
          height: 80px;
          line-height: 80px;
          text-align: center;
          border: 1px solid #dedede;
          border-top: 0;
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;
          display: inline-block;
          position: relative;
          top: -3px;
          font-size: 20px;
          color: #333333;
        }
      }
      .login-type-item:hover {
        box-shadow: 0 32px 46px -10px rgba(77, 89, 103, 0.14);
        border-radius: 8px;
        border-radius: 8px;
        span {
          border: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/menusNav.vue